import { DataModel } from "@toolpad/core/Crud";
import { INotificationDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

type NotificationDataModel = INotificationDto & DataModel;

export default function MessagesPage() {
  const columns: MagicCrudFields<INotificationDto>[] = [
    {
      field: nameof<INotificationDto>("sendDate"),
      headerName: "sendDate",
      type: "dateTime",
      editable: false,
      width: 180,
    },
    {
      field: nameof<INotificationDto>("emailRecipients"),
      headerName: "messageRecipients",
      type: "string",
      editable: false,
      width: 320,
      renderCell: (params: any) =>
        Array.isArray(params?.value) ? params.value.join(", ") : "-",
    },
    {
      field: nameof<INotificationDto>("id"),
      headerName: "messageId",
      type: "string",
      editable: false,
      width: 220,
    },
    {
      field: nameof<INotificationDto>("title"),
      headerName: "messageTitle",
      type: "string",
      editable: false,
      width: 220,
    },
    {
      field: nameof<INotificationDto>("body"),
      headerName: "messageBody",
      type: "string",
      editable: false,
      width: 300,
    },
  ];

  return (
    <MagicCrud<NotificationDataModel>
      name="messages"
      apiUrl="notifications"
      columns={columns}
      appUrl="/messages"
      customCreateLabel="sendMessage"
      disable={{ show: true, edit: true, delete: true }}
    />
  );
}
